var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customizer-layout-option"},[_c('div',{staticClass:"btn-group btn-radio-group",attrs:{"role":"group"}},_vm._l((_vm.opts),function(opt){return _c('button',{key:opt.key,class:{
      'btn btn-outline-secondary': true,
      'btn-active': opt.key === _vm.actKey
      },attrs:{"type":"button"},on:{"click":function($event){return _vm.click(opt)}}},[(_vm.icon)?_c('i',{class:opt.value}):_c('span',[_vm._v(_vm._s(opt.value))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }